import { useEffect, useState } from "react";
import { Dialog, Snackbar, Alert, Tooltip } from "@mui/material";
import { authData, withAdminAuth } from "../../components/GetAuth";
import { Link as RouterLink } from "react-router-dom";
import styles from "./companyprofile.module.css";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import { CountryList } from "../../components/Constants";
import { Copy, Edit3, Settings } from "react-feather";
import { StorageSetItem } from "../../components/StorageComp";
import CopyToClipboard from "react-copy-to-clipboard";
import axios from "axios";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import UpdateCompanyForm from "../../components/popups/UpdateCompanyForm";

const CompanyProfile = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [formOpenCompanyProfile, setFormOpenCompanyProfile] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [loading, setLoading] = useState(true);
  const [countryName, setCountryName] = useState("");
  const [companyData, setCompanyData] = useState(null);

  const { websiteData } = useWebsite();
  useSiteBranding("Company profile", websiteData);

  useEffect(() => {
    const fetchCompany = (id) => {
      axios.get(process.env.REACT_APP_API_URL + "v1/companies/" + id, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`
        }
      }).then((response) => {
        setLoading(false);
        setCompanyData(response.data.data);
      }).catch((error) => {
        setLoading(false);
      });
    }

    if (authData()?.company) {
      fetchCompany(authData()?.company?.id);
    }
  }, []);

  useEffect(() => {
    if (companyData?.company_address) {
      let conObj = CountryList?.filter(i => i?.value === companyData?.delivery_country);
      if (conObj?.length > 0) {
        setCountryName(conObj[0]?.label);
      }
    }
  }, [companyData]);

  const onCompanyUpdate = (data) => {
    setCompanyData(data);

    let authTemp = auth;
    let companyData = { id: data?.id, abb: data?.abb, company_name: data?.company_name, domain: data?.domain, pickup_country: data?.pickup_country, delivery_country: data?.delivery_country, urltoken: data?.urltoken }
    authTemp = { ...authTemp, company: companyData };

    StorageSetItem("bookAuthData", authTemp, 24 * 60 * 60 * 1000);
  }

  return (<div className={`${styles.MainDiv}`}>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <PageHeader title="Company Profile" />
    <div className={`${styles.MainCard}`}>
      <div className={`${styles.Container}`}>
        <div className={`${styles.CusRow}`}>
          <div className={`${styles.CustomerDeSec}`}>
            <div className={`${styles.UserProCard2}`}>
              <div className={`${styles.UserHead}`}>
                <p className={`${styles.UserProName}`}>{companyData?.company_name}</p>
                <div className={`${styles.UserHeadActions}`}>
                  <RouterLink className={`${styles.ProfileActionBU} ${styles.ProfileActionGhost}`} to={"/company-template"}><Settings /> Configure Template</RouterLink>
                  <RouterLink className={`${styles.ProfileActionBU} ${styles.ProfileActionPrimary}`} onClick={(e) => setFormOpenCompanyProfile(true)}><Edit3 /> Edit Company Profile</RouterLink>
                </div>
              </div>
              <div className={`${styles.UserProDe}`}>
                <p className={`${styles.UserProDeList}`}><span>Company Name:</span> {companyData?.company_name}</p>
                <div className={`${styles.CopyFieldRow}`}>
                  <span className={`${styles.CopyFieldLabel}`}>Domain:</span>
                  <div className={`${styles.CopyFieldValueWrap}`}>
                    <CopyToClipboard text={companyData?.domain}>
                      <Tooltip title={"Click to copy"}>
                        <span className={`${styles.CopyFieldValue}`}>{companyData?.domain}</span>
                      </Tooltip>
                    </CopyToClipboard>
                    <CopyToClipboard text={companyData?.domain}>
                      <Tooltip title={"Click to copy"}>
                        <Copy className={`${styles.CopyFieldIcon}`} />
                      </Tooltip>
                    </CopyToClipboard>
                  </div>
                </div>
                <p className={`${styles.UserProDeList}`}><span>Email:</span> {companyData?.email}</p>
                <p className={`${styles.UserProDeList}`}><span>Phone No:</span> {companyData?.phone}</p>
                <p className={`${styles.UserProDeList}`}><span>Company Addr:</span> {companyData?.company_address}</p>
                <p className={`${styles.UserProDeList}`}><span>Delivery Country:</span> {countryName}</p>
                <p className={`${styles.UserProDeList}`}><span>Reg Number:</span> {companyData?.reg_number}</p>
                <p className={`${styles.UserProDeList}`}><span>Vat Number:</span> {companyData?.vat_number}</p>
                <p className={`${styles.UserProDeList}`}><span>Payment Rec A/c:</span> {companyData?.payment_receiver_account}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog open={formOpenCompanyProfile} onClose={(e) => setFormOpenCompanyProfile(false)} fullWidth maxWidth="sm">
      <UpdateCompanyForm setFormOpen={setFormOpenCompanyProfile.bind(this)} onLocal={onCompanyUpdate.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={companyData} />
    </Dialog>

    <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={(e) => setSnackbarOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <Alert onClose={(e) => setSnackbarOpen(false)} severity={snackbarType} variant="filled" sx={{ width: "100%" }}>{snackbarMessage}</Alert>
    </Snackbar>
  </div >);
};

export default withAdminAuth(CompanyProfile);